module.exports = "/_next/static/images/7d884e77db6e740f0e696423215edfcc-multiproduct-lg.jpg";